import { ILogContext } from '../shared/types';

/**
 * Context manager for logger
 * Manages contextual information attached to all log entries
 */
export class LogContext {
	private context: ILogContext = {};

	constructor(defaultContext?: Record<string, any>) {
		if (defaultContext) {
			this.context = { ...defaultContext };
		}
	}

	/**
	 * Merge new context with existing context
	 * @param newContext - Partial context to merge
	 */
	public merge(newContext: Partial<ILogContext>): void {
		this.context = { ...this.context, ...newContext };
	}

	/**
	 * Clear context fields
	 * @param keys - Optional array of keys to clear. If not provided, clears all.
	 */
	public clear(keys?: string[]): void {
		if (!keys) {
			this.context = {};
		} else {
			keys.forEach((key) => delete this.context[key]);
		}
	}

	/**
	 * Get current context
	 * Returns a copy to prevent external mutations
	 */
	public get(): ILogContext {
		return { ...this.context };
	}

	/**
	 * Set context (replaces existing context)
	 * @param context - New context to set
	 */
	public set(context: ILogContext): void {
		this.context = { ...context };
	}
}
